import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from './http-gateway.service';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';
import { Observable, Observer } from 'rxjs';
import { Chain } from '../../shared/types/chain';

const CHAIN_URLS = {
    GET_HOTELS: 'api/ai-platform/load-chains',
    // GET_CURRENCY: 'api/admin/chain-currencies/load-data/{chainId}',
};

@Injectable({ providedIn: 'root' })
export class ChainService {
    private http = inject(HttpGatewayService);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public loadChains(): Observable<Chain[] | null> {
        return new Observable<Chain[] | null>((observer: Observer<Chain[] | null>) => {
            const availableChains = this.applicationStore.chains();

            if (!availableChains || availableChains.length === 0) {
                this.http.get<Chain[]>(CHAIN_URLS.GET_HOTELS).subscribe({
                    next: (chains: Chain[]) => {
                        const sortedChains = chains.sort((a, b) =>
                            a.displayName.localeCompare(b.displayName),
                        );

                        this.applicationStore.setChains(sortedChains);

                        observer.next(this.applicationStore.chains());
                        observer.complete();
                    },
                    error: (error) => {
                        observer.next(null);
                        observer.complete();
                    },
                });
            } else {
                observer.next(availableChains);
                observer.complete();
            }
        });
    }

    // public loadCurrency(chainId: number): Observable<ChainCurrencyContract> {
    //     const url = new UrlBuilder(CHAIN_URLS.GET_CURRENCY).addChainId(chainId).toUrl();
    //     return this.http.get(url);
    // }
}
